import http from 'plugins/axios';

export default {
  getArenaList(data) {
    return http.get({
      url: '/admin/arena/list',
      data
    });
  },
  create(data) {
    return http.post({
      url: '/admin/arena/add',
      data
    });
  },
  getDetail(data) {
    return http.get({
      url: '/admin/arena/detail',
      data
    });
  },
  update(data) {
    return http.post({
      url: '/admin/arena/update',
      data
    });
  },
  updateStatus(data) {
    return http.post({
      url: '/admin/arena/updateStatus',
      data,
      dataType: 'form'
    });
  },
  getRankList(data) {
    return http.get({
      url: '/admin/arena/rank',
      data
    });
  },
  editRank(data) {
    return http.post({
      url: '/admin/arena/addOrUpdateRank',
      data,
      dataType: 'form'
    });
  },
  getCurrentRank(data) {
    return http.get({
      url: '/admin/arena/currentRank',
      data
    });
  },
};
